import UpdateConfirmationCard from "Components/App/UpdateConfirmationCard/UpdateConfirmationCard";
import { Toast } from "lexus-style-guide/Components/Toast/Toast";
import { PropsWithChildren, FC } from "react";

interface Props {
    isOpen: boolean;
    onClick: () => void;
    message: string;
    hideClose?: boolean;
    onClose?: () => void;
}

type ToastWithChildrenProps = PropsWithChildren<{
    isOpen: boolean;
    onClose?: () => void;
    hideClose?: boolean;
    contentClass?: string;
    shouldCloseOnOverlayClick?: boolean;
    title?: string;
}>;

const ToastWithChildren = Toast as FC<ToastWithChildrenProps>;

const ConfirmationToast: FC<Props> = ({ isOpen, onClick, message, hideClose, onClose }) => (
    <ToastWithChildren isOpen={isOpen} hideClose={hideClose} onClose={onClose}>
        <UpdateConfirmationCard onClick={onClick} message={message} />
    </ToastWithChildren>
);

const UpdateConfirmation: FC<Props> = ({ isOpen, onClick, message, hideClose, onClose }) => {
    return (
        <ConfirmationToast
            isOpen={isOpen}
            onClick={onClick}
            message={message}
            hideClose={hideClose}
            onClose={onClose}
        />
    );
};

export default UpdateConfirmation;
